import styled from "styled-components"
import { when, maxWidth } from "utils"

export const Container = styled.nav`
  height: 6.3rem;
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "flex")};
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: ${({ hideMainNavOnMobile }) => (hideMainNavOnMobile ? 0 : 8)}rem;
  z-index: 4;
  background-color: ${(props) => props.theme.component.background || props.background};
  color: ${(props) => props.theme.component.text || props.color};

  ${maxWidth.desktopL`
    padding: 1.7rem 1.8rem;
  `}

  ${maxWidth.hamburgerLarge`
    height: 7rem;

    > :first-child {
      display: flex;
      overflow-x: scroll;
      white-space: nowrap;
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      a {
        width: max-content;
        margin: 0rem 1.25rem;
      }
    }

    button {
      display: none;
    }
  `}

  ${maxWidth.mobile`
    overflow-x: scroll;
    top: 6rem;

    > :first-child {
      display: flex;

      a {
        width: max-content;
        margin: 0rem 1.25rem;
      }
    }

    button {
      display: none;
    }
  `}
`

export const SectionLink = styled.a`
  margin: 0 1.25rem;
  font-size: 1.5rem;
  font-weight: 500;
  padding-bottom: 0.1rem;

  ${maxWidth.mobile`
    margin: 1.25rem 0;
  `}

  ${when("selected")`
    border-bottom: 0.2rem solid currentColor;
  `}

  :hover {
    border-bottom: 0.2rem solid currentColor;
  }
`
